<template>
  <div class="qeip text-dark" :class="{'qeip--active': edit}"
       v-on-clickaway="closeEdit"
       @mousedown="isMouseDown = true"
       @mouseup="isMouseDown = false">
    <div class="qeip--empty"
         v-if="!edit && textWithoutHTML.length < 1"
         @click="setEdit">
      <span class="icon-pencil"></span>
    </div>
    <div class="qeip--filled"
         @click="setEdit"
         v-if="!edit && textWithoutHTML.length > 0">
      <div v-html="text"></div>
    </div>
    <div v-if="edit">
      <quill-editor
          style="width: 100%"
          :content="text"
          :options="editorOption"
          @change="onEditorChange($event)"
          @ready="onEditorReady($event)">
        <div :id="'toolbar_' + uniqueNum" slot="toolbar" class="d-quill__toolbar"
             :data-num="uniqueNum">
          <!-- Add a bold button -->
          <button class="ql-bold hint--bottom" :aria-label="i18n[locale]['bold']">Bold</button>
          <button class="ql-italic hint--bottom" :aria-label="i18n[locale]['italic']">Italic</button>
          <button class="ql-underline hint--bottom" :aria-label="i18n[locale]['underline']">Underline</button>
          <button class="ql-list hint--bottom" value="ordered" :aria-label="i18n[locale]['list_ordered']">Ordered
          </button>
          <button class="ql-list hint--bottom" value="bullet" :aria-label="i18n[locale]['list_bullets']">bullet</button>
          <button id="custom-button" class="hint--bottom" :aria-label="i18n[locale]['insert_link']"
                  @click.prevent="setIsLinkModal(true)">
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"></line>
              <path class="ql-even ql-stroke"
                    d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"></path>
              <path class="ql-even ql-stroke"
                    d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"></path>
            </svg>
          </button>
        </div>
      </quill-editor>
      <div class="save-buttons" v-if="isInTestOfSaveButton">
        <button @click="cancel">{{ $t('vue2.common.cancel') }}</button>
        <button class="submit-button submit-button--disabled" v-if="!isChanged">{{ $t('vue2.common.save') }}</button>
        <button @click="save" class="submit-button" v-else>{{ $t('vue2.common.save') }}</button>
      </div>
    </div>
    <div class="bg-overlay" v-if="isClosingWithoutSaving"></div>
    <DModal v-if="isClosingWithoutSaving" class="ap" :show-close="false">
      <div class="quill-modal quill-modal__save-changes" slot="insertComponent">
        <h4 class="marg-20-bottom">{{ $t('vue2.common.save_changes') }}</h4>
        <div class="save-buttons">
          <button @click="cancel">{{ $t('vue2.common.cancel') }}</button>
          <button @click="save" class="submit-button">{{ $t('vue2.common.save') }}</button>
        </div>
      </div>
    </DModal>

    <div class="bg-overlay" v-if="isLinkModal"></div>
    <DModal v-if="isLinkModal" @close="setIsLinkModal(false)">
      <div class="quill-modal" slot="insertComponent">
        <div class="quill-modal__content">
          <div class="input-group">
            <label>{{ i18n[locale]['link_text_label'] }}</label>
            <input type="text" ref="linkTextInput" v-model="linkText"
                   :placeholder="i18n[locale]['link_text_placeholder']">
          </div>
          <div class="input-group">
            <label>{{ i18n[locale]['link_link_label'] }}</label>
            <input type="text" v-model="link" :placeholder="i18n[locale]['link_link_placeholder']">
          </div>
          <div class="quill-modal__footer">
            <button @click.prevent="setIsLinkModal(false)">{{ i18n[locale]['cancel'] }}</button>
            <button v-if="!isValidated" class="bttn bttn-primary submit-button submit-button--disabled">{{
                i18n[locale]['insert_link']
              }}
            </button>
            <button v-else @click.prevent="insertLink" class="bttn submit-button">{{ i18n[locale]['insert_link'] }}
            </button>
          </div>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import DModal from './DModal'
import eventbus from '../../eventbus'
import DoWeekPlanLog from '../Weekplan/DoWeekPlanLog'

export default {
  mixins: [clickaway],
  components: {
    quillEditor,
    DModal,
    DoWeekPlanLog
  },
  props: {
    isUploadFile: {
      type: Boolean,
      default: false
    },
    isUploadImage: {
      type: Boolean,
      default: false
    },
    textInput: {
      type: String,
      default: ''
    },
    lesson: {
      type: Object,
      default: () => null
    },
    noteType: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isInTestOfSaveButton: {
      type: Boolean,
      default: true
    },
    isInDCalendar: {
      type: Boolean,
      default: false
    },
    isKeepOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editor: null,
      uniqueNum: 1,
      isChanged: false,
      edit: false,
      text: '',
      linkText: '',
      link: '',
      isMouseDown: false,
      isLinkModal: false,
      editorOption: {},
      placeholder: '',
      isClosingWithoutSaving: false
    }
  },
  computed: {
    linkWithHttp () {
      // https://stackoverflow.com/questions/3543187/prepending-http-to-a-url-that-doesnt-already-contain-http
      const withHttp = url => !/^https?:\/\//i.test(url) ? `http://${url}` : url
      return withHttp(this.link)
    },
    isValidURL () {
      return this.checkValidURL(this.linkWithHttp)
    },
    isValidated () {
      return this.isValidURL && this.linkText.length > 0
    },
    textWithoutHTML () {
      return this.text ? this.text.replace(/<\/?p[^>]*>/g, '') : ''
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return {
        da: {
          bold: 'Fed',
          italic: 'Kursiv',
          underline: 'Understreget',
          list_ordered: 'Liste nummereret',
          list_bullets: 'Liste i punktform',
          insert_link: 'Indsæt link',
          link_text_label: 'Tekst der skal vises',
          link_text_placeholder: 'eks. Docendo',
          link_link_label: 'Webadressen',
          link_link_placeholder: 'eks. www.docendo.dk',
          cancel: 'Annuller'
        },
        en: {
          bold: 'Bold',
          italic: 'Italic',
          underline: 'Underline',
          list_ordered: 'List Ordered',
          list_bullets: 'List i punktform',
          insert_link: 'Insert link',
          link_text_label: 'Text to be shown',
          link_text_placeholder: 'e.g. Docendo',
          link_link_label: 'Web address',
          link_link_placeholder: 'e.g. www.docendo.co',
          cancel: 'Cancel'
        },
        nb: {
          bold: 'Fet',
          italic: 'Kursiv',
          underline: 'Understreket',
          list_ordered: 'Punktliste',
          list_bullets: 'Nummerert liste',
          insert_link: 'Sett inn link',
          link_text_label: 'Tekst som skal vises',
          link_text_placeholder: 'eks. Docendo',
          link_link_label: 'Nettadressen',
          link_link_placeholder: 'eks. www.docendo.no',
          cancel: 'Annuller'
        }
      }
    }
  },
  watch: {
    lesson: {
      handler (newValue, oldVal) {
        this.text = this.lesson[this.noteType]
      },
      deep: true
    },
    textInput (val) {
      if (!this.lesson) {
        this.text = val
      }
    }
  },
  methods: {
    checkValidURL (str) {
      return true
      /*
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
      return !!pattern.test(str)
       */
    },
    setIsLinkModal (boolean) {
      if (!boolean) {
        this.linkText = ''
        this.link = ''
      } else {
        setTimeout(_ => {
          this.$refs.linkTextInput.focus()
        }, 500)
      }
      this.isLinkModal = boolean
    },
    insertLink () {
      this.editor.focus()
      const index = (this.editor.getSelection() || {}).index || this.editor.getLength() - 1
      this.editor.insertText(index, this.linkText, 'link', this.linkWithHttp)
      this.setIsLinkModal(false)
    },
    onEditorReady (quill) {
      this.editor = quill
      quill.focus()
    },
    onUploadFile (e) {
      console.log('show some file uploading')
    },
    setEdit () {
      if (eventbus.isLessonNoteChangedWithoutSaving && !this.isInDCalendar) {
        return
      }
      // Quill operates with div id's for toolbar therefore we construct a new unique id different than the ones currently in DOM
      document.querySelectorAll('.d-quill__toolbar').forEach(el => {
        if (el.dataset.num >= this.uniqueNum) {
          this.uniqueNum = (el.dataset.num * 1) + 1
        }
      })
      this.editorOption = {
        modules: {
          toolbar: {
            container: '#toolbar_' + this.uniqueNum
          }
        },
        clipboard: {
          matchVisual: false
        }
      }
      this.$emit('open')
      this.edit = true
    },
    closeEdit (event) {
      if (this.isKeepOpen) {
        return
      }
      if (this.isInDCalendar) {
        this.edit = false
        return
      }
      if (this.isChanged && this.isInTestOfSaveButton) {
        this.isClosingWithoutSaving = true
        return
      }
      if (!this.isChanged && this.isInTestOfSaveButton) {
        this.edit = false
        return
      }
      if (event.target.classList.contains('ap')) {
        return
      }
      if (this.isMouseDown) {
        this.isMouseDown = false
        return
      }
      if (!this.edit) {
        return
      }
      if (this.lesson) {
        this.$emit('close', {lesson: this.lesson, noteType: this.noteType, text: this.text})
      } else {
        this.$emit('close', {text: this.text})
      }
      this.edit = false
    },
    cancel () {
      this.edit = false
      if (this.lesson) {
        this.text = this.lesson[this.noteType]
      } else {
        this.text = this.textInput
      }
      this.isClosingWithoutSaving = false
      this.isChanged = false
      this.$emit('close', false)
      eventbus.isLessonNoteChangedWithoutSaving = false
    },
    save () {
      this.edit = false
      if (this.lesson) {
        this.$emit('close', {lesson: this.lesson, noteType: this.noteType, text: this.text})
      } else {
        this.$emit('close', {text: this.text})
      }
      this.isClosingWithoutSaving = false
      this.isChanged = false
      eventbus.isLessonNoteChangedWithoutSaving = false
    },
    onEditorChange ({quill, html, text}) {
      this.text = html
      // Dont demand save if changes comes from database / other user
      if (this.textInput && (this.textInput === html)) {
        return
      }
      this.isChanged = true
      this.$emit('changed', this.text)
      if (this.isInTestOfSaveButton) {
        eventbus.isLessonNoteChangedWithoutSaving = true
      }
    }
  },
  beforeMount () {
    if (this.isOpen) {
      this.setEdit()
    }
  },
  mounted () {
    if (this.textInput) {
      this.text = this.textInput
      return
    }
    if (this.lesson && this.noteType) {
      this.text = this.lesson[this.noteType]
    }
    window.addEventListener('beforeunload', e => {
      const confirmMessage = 'Continue without saving?'
      if (eventbus.isLessonNoteChangedWithoutSaving) {
        (e || window.event).returnValue = confirmMessage // Gecko + IE
        return confirmMessage // Webkit, Safari, Chrome
      }
    })
  }
}
</script>


<style>
@import '../../assets/css/variables.css';

.qeip--empty {
  min-width: 20px;
  min-height: 20px;
  padding: 10px;
  cursor: pointer;
}

.qeip:hover {
  background-color: lightgoldenrodyellow;
}

.qeip--active.qeip:hover {
  background-color: transparent;
}

.qeip img {
  width: 100%;
}

.qeip .ql-editor {
  background-color: #ffffff;
  border-color: var(--blue);
}

.qeip .ql-toolbar {
  background: #f6f7f8;
}

.qeip .ql-editor ol, .qeip .ql-editor ul {
  padding-left: 1.5em;
}

.qeip button.ql-active {
  background: #dfdfdf !important;
}

.qeip--filled {
  font-size: 13px;
  padding: 10px;
}

.substitution .sub_teacher_notes .qeip--filled,
.substitution .sub_teacher_notes .ql-editor {
  font-size: 10px;
}

.qeip--filled ul, .qeip--filled ol {
  padding-left: 1.5em;
  margin: 0;
}

.qeip--filled ul li {
  list-style-type: disc;
}

.qeip--filled ol li {
  list-style-type: decimal
}

.qeip--filled a, .qeip--filled a:visited {
  color: rgb(0, 102, 204);
}

.ql-editor {
  overflow: visible;
}

.bg-overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .15s ease;
}

.quill-modal {
  width: 350px;
  background: #f6f9fc;
  padding: 20px;
  border-radius: 4px;
}

.quill-modal__save-changes {
  width: 300px;
  text-align: center;
}

.quill-modal__save-changes h4 {
  font-size: 18px;
}

.quill-modal__save-changes > .save-buttons {
  display: flex;
  justify-content: center;
}

.quill-modal__save-changes > .save-buttons > button {
  flex: 1;
}

.quill-modal__save-changes > .save-buttons > button:last-child {
  margin-left: 1rem;
}

.quill-modal__content .input-group label {
  margin-bottom: 5px;
}

.quill-modal__content .input-group {
  margin-bottom: 20px;
}

.quill-modal .input-group input {
  outline: 0 !important;
  border: 1px solid #edf2f7;
  width: 100%;
  -webkit-appearance: none !important;
  background: #fff;
  box-shadow: 0 2px 5px -1px rgba(50, 50, 93, .25), 0 1px 3px -1px rgba(0, 0, 0, .3);
  box-sizing: border-box !important;
  transition: background-color .24s, box-shadow .24s;
  border-radius: 4px;
}

.quill-modal .input-group input::placeholder {
  font-style: italic;
  font-size: 12px;
}

.quill-modal__footer {
  display: flex;
  justify-content: flex-end;
}

.quill-modal__footer .bttn.submit-button {
  padding: 2px 15px;
  margin-left: 10px;
}

.ql-snow .ql-editor a, .ql-snow .ql-editor a:visited {
  color: #06c;
}

/* STYLING FOR ROR */
.event .field .quill-on-lesson p {
  padding: 0
}

.ql-container .ql-editor ol li:not(.ql-direction-rtl),
.ql-container .ql-editor ul li:not(.ql-direction-rtl) {
  padding: 0;
}

.save-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.save-buttons > .submit-button {
  margin-left: 0.5rem;
}

.save-buttons__explainer {
  color: gray;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-right: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// AppEIPWYZIWYG.vue?a03b5fb2